const path = 'api/Portal/MarriageWorksheet'

const MaritalStatusEnum = {
    Single: 1,
    Divorced: 3,
    Widowed: 2
}

const WsStatusList = [{ id: 1, description: 'New' }]

const WsStatusEnum = {
    New: 1
}

const createNewApplicant = () => {
    return {
        firstName: null,
        middleName: null,
        lastName: null,
        priorLastName: null,
        suffix: null,
        sex: null,
        dateOfBirth: null,
        ssn: null,
        doesNotHaveSsn: null,
        placeOfBirthState: null,
        placeOfBirthCountry: null,
        placeOfBirthCountryOther: null,
        placeOfBirthStateOther: null,
        email: null,
        phone: null,
        residentialAddress: {},
        mailingAddress: {},
        diffMailingThanResidential: false,
        isFirstMarriage: null,
        maritalStatus: null,
        divorceDate: null,
        divorceCountry: null,
        divorceCountryOther: null,
        divorceState: null,
        divorceStateOther: null,
        widowedDate: null,
        ethnicity: null,
        ethnicityOther: null,
        education: null,
        motherFirstName: null,
        motherMiddleName: null,
        motherLastName: null,
        motherPriorLastName: null,
        motherSex: null,
        motherBirthPlaceCountry: null,
        motherBirthPlaceCountryOther: null,
        motherBirthPlaceState: null,
        motherBirthPlaceStateOther: null,
        unknownMother: null,
        fatherFirstName: null,
        fatherMiddleName: null,
        fatherLastName: null,
        fatherPriorLastName: null,
        fatherSex: null,
        fatherBirthPlaceCountry: null,
        fatherBirthPlaceCountryOther: null,
        fatherBirthPlaceState: null,
        fatherBirthPlaceStateOther: null,
        unknownFather: null,
        raceList: [],
        raceOther: null,
        raceOtherAsian: null,
        raceOtherPacificIslander: null
    }
}

const marriageWsSubmit = (http, wsDto) => {
    return http.post(`${path}/Submit`, wsDto)
}

const marriageWsSaveUnfinished = (http, wsDto) => {
    return http.post(`${path}/SaveUnfinished`, wsDto)
}

const marriageWsGet = (http, wsId) => {
    return http.get(`${path}/Get?WorksheetId=${wsId}`)
}

const marriageWsGetStatus = (http, wsId) => {
    return http.get(`${path}/GetStatus?WorksheetId=${wsId}`)
}

const getMarriageWorksheets = http => {
    return http.get(`${path}/GetInbox`)
}

const voidWs = (http, marriageWorksheetId) => {
    return http.delete(`${path}/voidWs?WorksheetId=${marriageWorksheetId}`)
}

const saveAcks = (http, marriageWorksheetId, selectedAcks) => {
    return http.post(`${path}/SaveAcks?worksheetId=${marriageWorksheetId}`, selectedAcks)
}

const print = (http, marriageWorksheetId) => {
    return http.get(`${path}/Print?worksheetId=${marriageWorksheetId}`)
}

const worksheetPrint = (http, marriageWorksheetDto) => {
    return http.post(`${path}/WorksheetPrint`, marriageWorksheetDto)
}

export default {
    MaritalStatusEnum: MaritalStatusEnum,
    WsStatusList: WsStatusList,
    WsStatusEnum: WsStatusEnum,
    marriageWsSubmit: marriageWsSubmit,
    marriageWsSaveUnfinished: marriageWsSaveUnfinished,
    marriageWsGet: marriageWsGet,
    marriageWsGetStatus: marriageWsGetStatus,
    getMarriageWorksheets: getMarriageWorksheets,
    voidWs: voidWs,
    saveAcks: saveAcks,
    print: print,
    worksheetPrint: worksheetPrint,
    createNewApplicant: createNewApplicant
}
